import { render, staticRenderFns } from "./CharacterOrderingSelect.vue?vue&type=template&id=e2ba0ae8&"
import script from "./CharacterOrderingSelect.vue?vue&type=script&lang=js&"
export * from "./CharacterOrderingSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports